import { Check } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function BookingStepper({ step }) {
  const { t } = useLang();
  const steps = t("bk.steps");

  return (
    <div className="flex items-center" data-testid="booking-stepper">
      {steps.map((label, index) => {
        const done = index < step;
        const active = index === step;
        return (
          <div key={label} className="flex items-center">
            <div className="flex items-center gap-2" aria-current={active ? "step" : undefined}>
              <span className={`flex h-6 w-6 items-center justify-center rounded-full text-[11px] font-semibold transition-colors ${
                done ? "bg-miles text-white" : active ? "border-2 border-miles bg-white text-miles" : "bg-ink/5 text-slate"
              }`}>
                {done ? <Check className="h-3.5 w-3.5" strokeWidth={2.5} /> : index + 1}
              </span>
              <span className={`hidden text-sm font-medium sm:block ${active ? "text-ink" : done ? "text-slate" : "text-slate/55"}`}>
                {label}
              </span>
            </div>
            {index < steps.length - 1 && <span className={`mx-3 h-px w-8 lg:w-12 ${done ? "bg-miles" : "bg-ink/10"}`} />}
          </div>
        );
      })}
    </div>
  );
}
